import $ from "jquery";
import { gotoURL } from "../FunctionsCore";
const socialShare = (socialShareParameter) => {
    $(() => {
        $(`.${socialShareParameter.facebookIdentifier}`).on("click", (cl) => {
            cl.preventDefault();
            gotoURL("https://www.facebook.com/sharer/sharer.php?u=");
        });
        $(`.${socialShareParameter.linkedInIdentifier}`).on("click", (cl) => {
            cl.preventDefault();
            gotoURL("https://www.linkedin.com/shareArticle?mini=true&url=");
        });
        $(`.${socialShareParameter.twitterIdentifier}`).on("click", (cl) => {
            cl.preventDefault();
            const siteTwitterHandle = socialShareParameter.siteTwitterHandle;
            const titleToUseUrlEncoded = socialShareParameter.titleToUseUrlEncoded;
            gotoURL(`https://twitter.com/share?text=${titleToUseUrlEncoded}&hashtags=Data&via=${siteTwitterHandle}&related=${siteTwitterHandle}&url=`);
        });
    });
};
export { socialShare };
